import apiConfig from '../api-config';
const api_base_url = apiConfig.api_base_url;
const api_key = apiConfig.api_key;

const fetchGraphData = async (endpoint) => {
  try {
    const response = await fetch(endpoint);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error(`Error fetching data from ${endpoint}:`, error);
    throw error;
  }
};

// Data Breach
export const getDataBreachRecord = () => fetchGraphData(`${api_base_url}/api/${api_key}/analytics/data/dbreach_rec`);

// Web & Network Analytics
export const getWebGraphData = () => fetchGraphData(`${api_base_url}/api/${api_key}/analytics/data/web`);
export const getNetworkGraphData = () => fetchGraphData(`${api_base_url}/api/${api_key}/analytics/data/network`);

// Cloud Services
export const getAWSCloudGraphData = () => fetchGraphData(`${api_base_url}/api/${api_key}/analytics/data/aws`);
export const getAzureCloudGraphData = () => fetchGraphData(`${api_base_url}/api/${api_key}/analytics/data/azure`);
export const getGCloudGraphData = () => fetchGraphData(`${api_base_url}/api/${api_key}/analytics/data/gcp`);

// Security Tools
export const getCrowdstrikeGraphData = () => fetchGraphData(`${api_base_url}/api/${api_key}/analytics/data/crowdstrike`);
export const getWiresharkGraphData = () => fetchGraphData(`${api_base_url}/api/${api_key}/analytics/data/wireshark`);
export const getAstraInternationalGraphData = () => fetchGraphData(`${api_base_url}/api/${api_key}/analytics/data/astra_international`);
export const getQualysGraphData = () => fetchGraphData(`${api_base_url}/api/${api_key}/analytics/data/qualys`);
export const getEttercapGraphData = () => fetchGraphData(`${api_base_url}/api/${api_key}/analytics/data/ettercap`);
export const getEGOGraphData = () => fetchGraphData(`${api_base_url}/api/${api_key}/analytics/data/ego`);
export const getSolarWindsGraphData = () => fetchGraphData(`${api_base_url}/api/${api_key}/analytics/data/solarwinds`);
export const getBreachlockGraphData = () => fetchGraphData(`${api_base_url}/api/${api_key}/analytics/data/breachlock`);
export const getBalbixGraphData = () => fetchGraphData(`${api_base_url}/api/${api_key}/analytics/data/balbix`);
export const getSkyboxGraphData = () => fetchGraphData(`${api_base_url}/api/${api_key}/analytics/data/skybox`);
export const getIndusfaceGraphData = () => fetchGraphData(`${api_base_url}/api/${api_key}/analytics/data/indusface`);
export const getSnortGraphData = () => fetchGraphData(`${api_base_url}/api/${api_key}/analytics/data/snort`);
export const getGFILanGuardGraphData = () => fetchGraphData(`${api_base_url}/api/${api_key}/analytics/data/gfi_languard`);
export const getVeracodeGraphData = () => fetchGraphData(`${api_base_url}/api/${api_key}/analytics/data/veracode`);
export const getHolmSecurityGraphData = () => fetchGraphData(`${api_base_url}/api/${api_key}/analytics/data/holm_security`);
export const getTripwireGraphData = () => fetchGraphData(`${api_base_url}/api/${api_key}/analytics/data/tripwire`);
export const getRapidGraphData = () => fetchGraphData(`${api_base_url}/api/${api_key}/analytics/data/rapid`);
export const getIntruderGraphData = () => fetchGraphData(`${api_base_url}/api/${api_key}/analytics/data/intruder`);
export const getSalesforceGraphData = () => fetchGraphData(`${api_base_url}/api/${api_key}/analytics/data/salesforce`);
export const getTenableGraphData = () => fetchGraphData(`${api_base_url}/api/${api_key}/analytics/data/tenable`);

// console.log(getDataBreachRecord());